import cn from 'clsx'

import { Copy } from 'shared-components'

import ImageBox from '../../ImageBox/ImageBox'

import Accordion from './Accordion'

import { type Accordion2Column as Accordion2ColumnType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './Accordion2Column.module.sass'

function Accordion2Column({ pretitle, title, copy, image, accordionItems }: Accordion2ColumnType) {
    return (
        <section className={s.Accordion2Column}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Main}>
                    <div className={s.Intro}>
                        {pretitle && <span className='smallCaps' dangerouslySetInnerHTML={{ __html: pretitle }} />}
                        {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                        {copy && (
                            <div className={s.Copy}>
                                <Copy copy={copy} />
                            </div>
                        )}
                    </div>
                    <Accordion items={accordionItems} />
                </div>
                <div className={s.Image}>
                    {image &&
                        <ImageBox image={image} />
                    }
                </div>
            </div>
        </section>
    )
}

export default Accordion2Column
